import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Divider,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { StatusIcon } from "../../../icons";
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
export default function CounselingDetailsModal({ open,counseling, onClose, request }) {


  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: "16px" } }}
    >
      {/* Title with Close Button */}
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography sx={{ fontWeight: 600, fontSize: "20px", color: "#15243E" }}>
          Request Details
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        {/* Student Profile */}
          <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#6E7485", mb: 1, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            Student Profile <Typography variant="span" sx={{background:'#FFECA0',border:'1px solid #FFE187', color:'#FF6E20', fontSize:'12px', borderRadius:'20px', px:2,}}>{counseling?.status}</Typography>
          </Typography>
        <Box mb={2} sx={{border:'1px solid #ccc', background:'#E3F2FD', p:2, borderRadius:'8px',}}> 
          <Typography sx={{ fontSize: "20px", mb: 0.5,color:'#363853', fontWeight:'500' }}>
           {counseling?.studentDetails}
          </Typography>
          <Typography sx={{ fontSize: "16px", mb: 1.5, color:'#363853', }}>
          {counseling?.universityName}
          </Typography>
          <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
            <strong>Mobile:</strong> {counseling?.phoneNumber}
          </Typography>
          <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
            <strong>University:</strong> {counseling?.universityName}
          </Typography>
          <Typography sx={{ fontSize: "14px", mb: 0.5 }}>
            <strong>Email:</strong> {counseling?.emailID}
          </Typography>
          <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#363853", py: 0.5 }}>
            <strong>Message:</strong> <Typography variant="span" sx={{ fontWeight: "normal" }}>{counseling?.message}</Typography>
          </Typography>
        </Box> 


        {/* Status History */}
        <Box mb={2}>
          <Typography sx={{ fontWeight: 500, fontSize: "14px", color: "#6E7485", mb: 1, display:'flex', alignItems:'center', gap:0.5, }}>
            <StatusIcon /> Status History
          </Typography>
          <Box sx={{border:'1px solid #ccc', p:2, borderRadius:'8px',}}>
            { counseling?.history?.map(item=> <Box key={item?.id} sx={{display:"flex", alignItems:'start', gap:1, mb:2 }}>
                  <FiberManualRecordIcon sx={{fontSize:'18px', color:'#363853',}} />
                 <Box  sx={{width:'100%'}}> 
                    <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center', mb:1}}>
                    <Typography sx={{ fontSize: "12px", border:'1px solid #6E7485', color:'#6E7485', borderRadius:'50px', display:'inline-block', px:2, }}>{item?.status}</Typography>
                  <Typography sx={{ fontSize: "12px", color: "#363853" }}>{item?.date}</Typography> 
                  </Box>
                  <Typography sx={{ fontSize: "12px", color: "#363853" }}>{item?.comment}</Typography> 
                  <Typography sx={{ fontSize: "12px", color: "#363853" }}>Updated by: {item?.updatedBy}</Typography>
                  </Box>
                  </Box>)
            }
          </Box>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button onClick={onClose} variant="outlined" sx={{ width: "100%", height: "50px" }}>
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
}
